// extracted by mini-css-extract-plugin
export default {"wrapper":"Menu_wrapper__NyAq8","inner":"Menu_inner__XDfDZ","overlay":"Menu_overlay__N3fya"};